/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ hostname: NonNullable<unknown> }} Disabled_Websites_Already_Enabled_Limited_Cannot_AddInputs */

const en_disabled_websites_already_enabled_limited_cannot_add = /** @type {(inputs: Disabled_Websites_Already_Enabled_Limited_Cannot_AddInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hostname} is already enabled with limited compatibility. You can't add it to disabled websites.`)
};

const es_disabled_websites_already_enabled_limited_cannot_add = /** @type {(inputs: Disabled_Websites_Already_Enabled_Limited_Cannot_AddInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hostname} ya está habilitado con compatibilidad limitada. No puedes agregarlo a sitios deshabilitados.`)
};

/**
* | output |
* | --- |
* | "{hostname} is already enabled with limited compatibility. You can't add it to disabled websites." |
*
* @param {Disabled_Websites_Already_Enabled_Limited_Cannot_AddInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const disabled_websites_already_enabled_limited_cannot_add = /** @type {((inputs: Disabled_Websites_Already_Enabled_Limited_Cannot_AddInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Disabled_Websites_Already_Enabled_Limited_Cannot_AddInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_disabled_websites_already_enabled_limited_cannot_add(inputs)
	return en_disabled_websites_already_enabled_limited_cannot_add(inputs)
});